import { useEffect, useRef } from 'react';

export function useReportDirty(dirty: boolean, onDirtyChange?: (dirty: boolean) => void) {
  const onDirtyChangeRef = useRef(onDirtyChange);
  onDirtyChangeRef.current = onDirtyChange;

  useEffect(() => {
    onDirtyChangeRef.current?.(dirty);
    return () => {
      onDirtyChangeRef.current?.(false);
    };
  }, [dirty]);
}
